import ImageWrapper from "../ImageComponent/ImageWrapper";
import { useRouter } from "next/router";

const RightImageBox = ({ imageUrl, altText, onClick }) => {
  const router = useRouter();
  const handleClick = ()=>{
    router.push('/temple')
  }
  return (
    <div className="sm:h-[240px] md:w-[270px] md:h-[420px] lg:w-352 lg:h-460 overflow-hidden rounded-xl shadow-md bg-white hover:shadow-xl transition-shadow duration-300 ease-in-out relative">
      
      {/* New Tag */}
      <div className="absolute top-0 right-0 p-2 z-10" >
        <span className="inline-block bg-gradient-to-r from-yellow-400 to-orange-500 text-white font-semibold text-sm px-3 py-1 rounded-xl shadow-lg animate-pulse border-2 border-transparent hover:border-yellow-400 glow-tag">
          New
        </span>
      </div>

      {/* Image */}
      <div className="w-full h-38 xs:h-48 sm:h-60 md:w-[270px] md:h-[420px] lg:w-352 lg:h-460 overflow-hidden rounded-xl shadow-md bg-white hover:shadow-xl transition-shadow duration-300 ease-in-out relative">
        <ImageWrapper
          src={imageUrl}
          alt={altText}
          className="h-full w-full object-cover"
          onClick={onClick}
        />
      </div>
    </div>
  );
};

export default RightImageBox;

